// Pure helpers for the Dashboard: status groupings and labels the screens share.
// The aggregates themselves come from the API (`docs/api.md` §16), already
// scoped to what the caller may see. No I/O here.
// The terminal statuses are `TERMINAL_STATUSES` in `@ap/shared`, imported where
// they are read; this file kept its own copy until code review D-04 / H-11.
import { DENIAL_OUTCOMES as SHARED_DENIAL_OUTCOMES } from '@ap/shared'

/**
 * Decision outcomes that end a record's run: a denial or one of the archives.
 * `DENIAL_OUTCOMES` from `@ap/shared` (question 4.10). `escalated` is
 * deliberately NOT here: an automatic movement off Department Approval is not
 * a denial and must not be counted as one.
 */
export const DENIAL_OUTCOMES: readonly string[] = SHARED_DENIAL_OUTCOMES

/** Human labels for the fields that show up as correction targets. */
const CORRECTION_FIELD_LABELS: Record<string, string> = {
  vendor_id: 'Vendor',
  company_id: 'Company',
  // The GL code is three correctable fields now: the two halves, edited
  // separately by different people at different steps, and the composed value
  // written whole at Export Control and Manual Entry.
  account_id: 'Account',
  department_id: 'Department',
  final_code_id: 'Code',
  external_invoice_id: 'Invoice #',
  invoice_date: 'Date',
  subtotal: 'Subtotal',
  tax: 'Tax',
  total: 'Total',
  description: 'Line Description',
  quantity: 'Quantity',
  unit_price: 'Price',
  LineAdded: 'Line Added',
  LineRemoved: 'Line Removed',
  // Every field the editor writes is a correction target since D-328
  // (2026-10-08), the Additional Detail and the tags included.
  shipping: 'Shipping',
  currency: 'Currency',
  document_type: 'Document Type',
  line_number: 'Line Number',
  printed_code: 'Printed Code',
  marketing_category_id: 'Marketing Category',
  EntityAdded: 'Associated Entity Added',
  EntityRemoved: 'Associated Entity Removed',
  entity_name: 'Associated Entity Name',
  entity_vehicle_id: 'Associated Entity Vehicle',
  entity_staff_upn: 'Associated Entity Staff',
  entity_line_item_id: 'Associated Entity Line',
}

export function correctionFieldLabel(field: string | undefined | null): string {
  return (field && CORRECTION_FIELD_LABELS[field]) || field || '(unknown)'
}
